import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import {
  annualDfiReportYearState,
  dfiReportBestPracticeResponseState,
  dfiReportInfoOnLateResponseState,
} from 'store';
import { API_QUERY_KEYS, getDfiAnnualReport, QueryDefaults } from 'api';
import { DfiReportResponse } from 'types';

export const useDfiAnnualReport = (): UseQueryResult<DfiReportResponse> => {
  const reportYear = useRecoilValue(annualDfiReportYearState);
  const setInitiativesResponse = useSetRecoilState(dfiReportBestPracticeResponseState);
  const setIssuesResponse = useSetRecoilState(dfiReportInfoOnLateResponseState);

  return useQuery(
    [API_QUERY_KEYS.getDfiAnnualReport, reportYear],
    () => getDfiAnnualReport(reportYear),
    {
      ...QueryDefaults,
      onSuccess: (data: DfiReportResponse) => {
        setInitiativesResponse(data.bestPracticeResponse);
        setIssuesResponse(data.infoOnLateResponse);
      },
    }
  );
};
